$(document).ready(function () {
    let review_slider = $(".review_content_block");
    review_slider.slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev"><svg aria-label="previous" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="25" cy="25" r="25" transform="matrix(-1 0 0 1 50 0)" fill="#1C3321"/> <path d="M26 29L22 25L26 21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg aria-label="next" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="25" cy="25" r="25" fill="#1C3321"/> <path d="M24 29L28 25L24 21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    // let reviewSlideCount = review_slider.slick('getSlick').slideCount;
    // if (reviewSlideCount > 4) {
    //     review_slider.slick('slickSetOption', 'dots', true, true);
    // }
});
